import Vue from 'vue'
import VueEventManager from 'vue-event-manager'

Vue.use(VueEventManager, {})